import { render, staticRenderFns } from "./instructions_header_image_one_button.vue?vue&type=template&id=3c58633e&scoped=true&"
import script from "./instructions_header_image_one_button.vue?vue&type=script&lang=js&"
export * from "./instructions_header_image_one_button.vue?vue&type=script&lang=js&"
import style0 from "./instructions_header_image_one_button.vue?vue&type=style&index=0&id=3c58633e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58633e",
  null
  
)

export default component.exports